// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1q9P8","detailsBorder":"styles_detailsBorder__2EFRQ"};